<div class="container well">
    <div class="well-title">
        <div class="col-md-12">Upload Invoice</div>
    </div>
    <div class="col-md-12 well-content">
        @if (!loading && !hasZonalScanDir) {
            <div>A Zonal OCR scan directory must be created before uploading invoices.</div>
        }

        @if (!loading && hasZonalScanDir) {
            <form class="form-horizontal" (ngSubmit)="upload()">
                <div class="form-group">
                    <label class="control-label col-md-2">TIFF/PDF</label>
                    <div class="col-md-4">
                        <input
                            type="file"
                            class="form-control"
                            accept=".tif,.tiff,.pdf"
                            (change)="onFileChange($event)" />
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-offset-2 col-md-4">
                        <button type="submit" class="btn btn-default" [disabled]="uploading || !selectedFile">
                            {{ uploading ? "Uploading..." : "Upload" }}
                        </button>
                    </div>
                </div>
            </form>
        }
    </div>
</div>
